import AppEvents from 'Shared/app-events';
import CartApi from 'Api/cart-api';
import Util from 'Common/util';

class StatusBarModel {
    constructor(params) {
        AppEvents.on("Store.QuantitySelected", (model) => {
            const item = this.activeItems()
                .find(x => {
                    if (x.data().key) {
                        return x.data().key == model.data().key;
                    }

                    return x.data().ProductId == model.data().ProductId
                        && x.data().ProductUnitId == model.data().ProductUnitId
                });

            if (item) {
                if (!model.value()) {
                    this.activeItems.remove(item);
                }
            } else {
                this.activeItems.push(model);
            }
        });
    }

    activeItems = ko.observableArray([]);

    itemsToAdd = ko.pureComputed(() => {
        console.log(this);
        return this.activeItems().length;
    });

    statusCss = ko.pureComputed(() => {
        let classes = [];
        if (this.activeItems().length > 0) {
            classes.push("is--enabled");
        }

        return classes.join(' ');
    });

    addToCart = async (model, e) => {
        //Util.startLoading(e.target);

        const items = this.activeItems()
            .map(item => item.data());

        AppEvents.emit("StatusBar.Add", {
            element: e.target,
            items: items
        });

        const activeItems = [...this.activeItems()]
        // reset active items
        for (let item of activeItems) {
            item.clear();
        }


        //await CartApi.addProducts(products);

        //AppEvents.emit("aside.cart.show");

        

        //Util.stopLoading(e.target);
    }
}

ko.components.register('statusbar', {
    viewModel: {
        createViewModel: (params, componentInfo) => new StatusBarModel(params, componentInfo)
    },
    template: { element: 'store-status-bar' }
});